import * as React from 'react';
import ReactDOM from 'react-dom/client';

import { isConsentCategoryDisabled } from '@/tscapi/utils/consent';

import TrueFitCheckout from './truefit-checkout.component';

/* prevent truefit if functional consent disabled or TrueFitEnabled is false */
{
    window.tscConfig?.['TrueFitEnabled'] == 'true' &&
        !isConsentCategoryDisabled('functional') &&
        document.addEventListener(
            'order-confirmed',
            function (e: CustomEvent) {
                const checkExist = setInterval(function () {
                    const truefitCartElement = document.getElementById('tf-checkout-wrapper') as HTMLElement;
                    if (truefitCartElement != undefined) {
                        clearInterval(checkExist);
                        const root = ReactDOM.createRoot(truefitCartElement);
                        root.render(
                            <React.StrictMode>
                                <TrueFitCheckout detail={e.detail} />
                            </React.StrictMode>,
                        );
                    }
                }, 100); // check every 100ms
            }.bind(this),
            false,
        );
}
